export default __webpack_public_path__ + "static/media/loader.0725b480.gif";